// Invitation secrets stay in memory, never storage, query strings or telemetry.
export function invitationFromFragment(fragment: string): string {
  const value = new URLSearchParams(fragment.replace(/^#/, '')).get('invite')?.trim() ?? '';
  return value.length <= 256 ? value : '';
}

export function consumeDocumentInvitation(): string {
  if (typeof window === 'undefined' || window.location.pathname !== '/register') return '';
  const invitation = invitationFromFragment(window.location.hash);
  // Clear even malformed invitation fragments before React renders or requests account data.
  if (window.location.hash) {
    window.history.replaceState(
      window.history.state,
      '',
      window.location.pathname + window.location.search,
    );
  }
  return invitation;
}

let initialInvitation = consumeDocumentInvitation();

export function initialRegistrationInvitation(): string {
  return initialInvitation;
}

export function forgetInitialRegistrationInvitation(): void {
  initialInvitation = '';
}
